import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addcommas',
  standalone: true,
})
export class AddCommasPipe implements PipeTransform {
  // Agrega comas de separación en el número indicado
  transform(value: string | number): string | number {
    try {
      return value.toString().replace(/\B(?=(?:\d{3})+(?!\d))/g, ",");
    } 
    catch {
      return value;
    }
  }
}
